'use client';
import { Adsense } from '@/components/adsense';

export function AdsenseSquare({ visible }: { visible?: boolean }) {
  return (
    <section className="w-full py-4 px-4 flex flex-col rounded-sm bg-stone-100 dark:bg-stone-900">
      <div className="w-full max-h-[336px]">
        <Adsense visible={visible} />
      </div>
    </section>
  );
}
